import PropTypes from 'prop-types';
import React from 'react';

import { SecondaryHeading } from 'components/Headings';
import Modal from 'components/Modal';
import Paragraph from 'components/Paragraph';
import { mediumUp } from 'constants/mediaQueries';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

const OurCommitmentModal = class extends React.PureComponent {
  render() {
    const { isOpen, closeModal, modalSettings } = this.props;

    return (
      <Modal
        isOpen={isOpen}
        className="OurCommitmentModal"
        portalClassName="OurCommitmentModal__portal"
        onRequestClose={closeModal}
        {...modalSettings}
      >
        <div className="OurCommitmentModal__content">
          <SecondaryHeading className="OurCommitmentModal__heading">
            {I18n.localize('commitmentPage.modal.heading')}
          </SecondaryHeading>
          <div className="OurCommitmentModal__earth">
            <img
              src="https://cdn.allbirds.com/image/upload/f_auto,q_auto/v1554921274/earth-day/our-commitment/earth.gif"
              alt="Earth"
              width={300}
              height={300}
            />
          </div>
          <Paragraph className="OurCommitmentModal__body">
            {I18n.localize('commitmentPage.modal.subText')}
          </Paragraph>
        </div>
        <style jsx global>{`
          .-secondary-heading.OurCommitmentModal__heading {
            text-align: center;
            margin-bottom: ${Theme.get('spacing-px')};
          }

          .OurCommitmentModal__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
          }

          .OurCommitmentModal__earth {
            width: 200px;
            margin-bottom: ${Theme.get('spacing-px')};
          }

          @media ${mediumUp} {
            .OurCommitmentModal__earth {
              width: 300px;
            }
          }

          .Paragraph.OurCommitmentModal__body {
            text-align: center;
            margin-bottom: 0;
          }
        `}</style>
      </Modal>
    );
  }
};

OurCommitmentModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  modalSettings: PropTypes.shape({}),
};

OurCommitmentModal.defaultProps = {
  modalSettings: {},
};

export default OurCommitmentModal;
